import React, { useState, useContext, useEffect } from 'react';
import './Sidebar.css';
import { useNavigate, NavLink } from 'react-router-dom';
import AuthContext from "../../context/Services/Auth";
import { get_branding } from "../../context/Services/Branding";

import defaultLogo from '../../Assets/logo/logo_white.png';

import { MdOutlineAddChart, MdOutlineLogout } from "react-icons/md";
import { BiPackage } from "react-icons/bi";
import { GrUserAdmin } from "react-icons/gr";
import { IoSettingsOutline } from "react-icons/io5";
import { FaRegCircleCheck, FaDollarSign } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa";
import { LiaShippingFastSolid } from "react-icons/lia";
import { TbReportMoney } from "react-icons/tb";
import { FiBox } from "react-icons/fi";
import { MdClear, MdLanguage } from "react-icons/md";
import { useTranslation } from 'react-i18next';



const tabs = [
	{
		access: ["admin", "employee"],
		value: MdOutlineAddChart,
		name: 'Dashboard',
		path: ''
	},
	{
		access: ["admin"],
		value: GrUserAdmin,
		name: 'My Staff',
		path: 'staff'
	},
	{
		access: ["admin", "employee"],
		value: BiPackage,
		name: 'My Stock',
		path: 'stock'
	},
	{
		access: ["admin", "employee", "commercial"],
		value: LiaShippingFastSolid,
		name: 'Livraison',
		path: 'shipments',
		cut: true
	},
	{
		access: ["admin", "employee"],
		value: TbReportMoney,
		name: 'Frais',
		path: 'costs'
	},
	{
		access: ["admin", "employee"],
		value: FiBox,
		name: 'Fournisseur',
		path: 'suppliers',
	},
	{
		access: ["admin"],
		value: FaUsers,
		name: 'Clients',
		path: 'clients',
		cut: true
	},
];

const languages = [
	{ code: 'fr', label: 'Français' },
	{ code: 'ar', label: 'العربية' },
];


const Sidebar = ({ showSideBar, setShowSideBar }) => {
	const { t, i18n } = useTranslation();
	const [activeTab, setActiveTab] = useState(tabs[0].name);
	const [showLangDropdown, setShowLangDropdown] = useState(false);
	const [logo, setLogo] = useState(defaultLogo);
	const navigate = useNavigate();

	const { logoutUser, userData } = useContext(AuthContext);

	const currentLang = languages.find(l => l.code === i18n.language) || languages[0];

	// Fetch dynamic logo
	useEffect(() => {
		const fetchLogo = async () => {
			try {
				const res = await get_branding('website_logo');
				if (res?.data) {
					setLogo(res.data);
				}
			} catch (e) {
				console.log('Using default logo');
			}
		};
		fetchLogo();
	}, []);

	// Lock body scroll when sidebar is open
	useEffect(() => {
		if (showSideBar) {
			document.body.classList.add('sidebar-open');
		} else {
			document.body.classList.remove('sidebar-open');
		}
		return () => document.body.classList.remove('sidebar-open');
	}, [showSideBar]);

	const handleLanguageChange = (langCode) => {
		i18n.changeLanguage(langCode);
		setShowLangDropdown(false);
	};

	const closeSidebar = () => setShowSideBar(false);

	return (
		<>
			{/* Backdrop overlay */}
			<div
				className={`sidebar_backdrop ${showSideBar ? 'sidebar_backdrop_visible' : ''}`}
				onClick={closeSidebar}
			/>

			<div className={`Sidebar_main flex flex-col shadow ${showSideBar && "show_sidebar"}`}>
				<div className="tabs_section flex flex-col">
					<MdClear className="remove_sidebar_icon pointer" onClick={closeSidebar} />
					<img src={logo} className="sidebar_logo sidebar_logo_side" alt="logo" />

					{tabs.map((tab, i) => (
						tab?.access.includes(userData?.role) &&
						<>
							<NavLink key={i} onClick={closeSidebar} to={`/${tab.path}`} className={({ isActive }) => isActive ? 'flex gap w-full items-center tab tab_active' : 'flex gap w-full items-center tab'}>
								<tab.value className="tab_icon" />
								<p className="tab_text_sidebar">
									{t(tab?.name)}
								</p>
							</NavLink>
						</>
					))}

					{/* Language Selector */}
					<div className="sidebar_lang_section">
						<div
							className="flex gap w-full items-center tab sidebar_lang_btn"
							onClick={() => setShowLangDropdown(!showLangDropdown)}
						>
							<MdLanguage className="tab_icon" />
							<p className="tab_text_sidebar">{currentLang.label}</p>
						</div>
						{showLangDropdown && (
							<div className="sidebar_lang_dropdown">
								{languages.map((lang) => (
									<div
										key={lang.code}
										className={`sidebar_lang_option ${i18n.language === lang.code ? 'sidebar_lang_active' : ''}`}
										onClick={() => handleLanguageChange(lang.code)}
									>
										{lang.label}
									</div>
								))}
							</div>
						)}
					</div>

					<div className="flex gap w-full items-center tab tab_active tab_logout" onClick={logoutUser}>
						<MdOutlineLogout className="tab_icon" />
						<p className="tab_text_sidebar">{t("Logout")}</p>
					</div>

				</div>

			</div>
		</>
	)
}

export default Sidebar